import { createFileRoute } from '@tanstack/react-router';

import { AllSprites } from '@/features/sprites/sprites-list';

export const Route = createFileRoute('/_authenticated/sprites/')({
  component: AllSprites,
});
